import Movable from '../../../svgchartlib-v3/includes/mixins/Movable.mixin'

export default Movable